import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { isPlatformAdminScreen, platformAdminHome } from './platform-admin';

@Injectable({ providedIn: 'root' })
export class PlatformAdminGuard implements CanActivateChild {
  constructor(private authService: AuthService, private router: Router) {}

  canActivateChild(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!this.authService.getUser().isStaff || isPlatformAdminScreen(state.url)) return true;
    return this.router.parseUrl(platformAdminHome);
  }
}
